import React from 'react';
import * as DEFAULT_COLORS from '../../constants/defaultColors';

export const defaultCard = {
  style: {
    height: 300,
    width: 250,
    borderRadius: 50,
    padding: 20,
    margin: '5px 20px 5px 5px',
    backgroundImage: `linear-gradient(60deg, ${DEFAULT_COLORS.DEFAULT_CARD_BG_COLOR1}, ${DEFAULT_COLORS.DEFAULT_CARD_BG_COLOR2})`,
    boxShadow: `7px -7px 14px 0px ${DEFAULT_COLORS.DEFAULT_CARD_SHADOW_COLOR1}, -7px 7px 14px 0px ${DEFAULT_COLORS.DEFAULT_CARD_SHADOW_COLOR2}`,
  },
  backgroundImageAngle: 45,
  bgColorsList: [DEFAULT_COLORS.DEFAULT_CARD_BG_COLOR1, DEFAULT_COLORS.DEFAULT_CARD_BG_COLOR2],
  boxShadow: [[7, -7, 14, 0, DEFAULT_COLORS.DEFAULT_CARD_SHADOW_COLOR1], [-10, 10, 20, 0, DEFAULT_COLORS.DEFAULT_CARD_SHADOW_COLOR2]],
  margins: [5, 20, 5, 5] // easier to handle each margin separately
};


const setCardStyle = () => {};

const CardContext = React.createContext({cardStyle: defaultCard, setCardStyle});

export default CardContext;
